import type { ClienteAgregado } from '@/lib/cuadro/agregaciones';
import { textoSinLlamadas } from '@/lib/cuadro/filtros';

// «Clientes que más llaman» (change 003): mismo tratamiento que los motivos. El
// color dice qué es cada barra: navy para un cliente, gris para lo que no es un
// cliente concreto («Sin identificar» y «Resto»).
export function ClientesQueMasLlaman({
  clientes,
  periodoVacio,
}: {
  clientes: ClienteAgregado[];
  periodoVacio: boolean;
}) {
  if (clientes.length === 0) {
    return (
      <p data-testid="clientes-vacio" className="text-[12.5px] text-[var(--text-dim)]">
        {textoSinLlamadas(periodoVacio)}.
      </p>
    );
  }
  const mayor = Math.max(...clientes.map((c) => c.total), 1);
  return (
    <ul data-testid="clientes-que-mas-llaman" className="m-0 list-none space-y-2.5 p-0">
      {clientes.map((c) => {
        const esCliente = c.tipo === 'cliente';
        return (
          <li key={c.clave} data-testid="cliente-barra" className="text-[12px]">
            <div className="mb-1 flex items-center gap-2 text-[var(--text-2)]">
              <span
                title={c.etiqueta}
                className={`min-w-0 flex-1 truncate ${esCliente ? '' : 'text-[var(--text-dim)]'}`}
              >
                {c.etiqueta}
              </span>
              <span className="mono font-semibold text-[var(--navy)]">{c.total}</span>
              <span className="mono w-9 text-right text-[var(--text-dim)]">{c.pct}%</span>
            </div>
            <div className="h-1.5 overflow-hidden rounded-full bg-[var(--surface-3)]">
              <div
                className={`h-full rounded-full ${
                  esCliente ? 'bg-[var(--navy)] opacity-80' : 'bg-[var(--text-mute)] opacity-60'
                }`}
                style={{ width: `${(c.total / mayor) * 100}%` }}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
